import { OfferTaskLabel } from '../route';

// TODO: We may need more of these to be Zod schemas
export enum ApplicantOfferRequirement {
  Passport = 'Passport',
  PhotoID = 'PhotoID',
  AcademicResults = 'AcademicResults',
  AcademicCertificate = 'AcademicCertificate',
  AcademicTranscript = 'AcademicTranscript',
  EnglishLanguageResults = 'EnglishLanguageResults',
  EnglishLanguageCertificate = 'EnglishLanguageCertificate',
  CV = 'CV',
  ProofOfManagerialExperience = 'ProofOfManagerialExperience',
  ProofOfAddress = 'ProofOfAddress',
  ProofOfNameChange = 'ProofOfNameChange',
  NameAffidavit = 'NameAffidavit',
  BirthCert = 'BirthCert',
  ProofOfImmigrationStatus = 'ProofOfImmigrationStatus',
  LetterOfRecommendation = 'LetterOfRecommendation',
  PersonalStatement = 'PersonalStatement',
  Portfolio = 'Portfolio'
}

// TODO: Think of a better name
export enum ApplicantOfferRequirementLevel {
  Off = 'Off',
  PreOffer = 'PreOffer',
  Condition = 'Condition',
  PreEnrolment = 'PreEnrolment'
}

/**
 * Maps endpoint URL segments to ApplicantOfferRequirement enum values
 */
export const endpointToRequirementEnum = new Map<string, ApplicantOfferRequirement>([
  ['passport', ApplicantOfferRequirement.Passport],
  ['photo-id', ApplicantOfferRequirement.PhotoID],
  ['proof-of-name-change', ApplicantOfferRequirement.ProofOfNameChange],
  ['name-affidavit', ApplicantOfferRequirement.NameAffidavit],
  ['birth-certificate', ApplicantOfferRequirement.BirthCert],
  ['academic-results', ApplicantOfferRequirement.AcademicResults],
  ['academic-certificate', ApplicantOfferRequirement.AcademicCertificate],
  ['academic-transcript', ApplicantOfferRequirement.AcademicTranscript],
  ['english-language-results', ApplicantOfferRequirement.EnglishLanguageResults],
  ['english-language-certificate', ApplicantOfferRequirement.EnglishLanguageCertificate],
  ['cv', ApplicantOfferRequirement.CV],
  ['proof-of-managerial-experience', ApplicantOfferRequirement.ProofOfManagerialExperience],
  ['proof-of-address', ApplicantOfferRequirement.ProofOfAddress],
  ['proof-of-immigration-status', ApplicantOfferRequirement.ProofOfImmigrationStatus],
  ['letter-of-recommendation', ApplicantOfferRequirement.LetterOfRecommendation],
  ['personal-statement', ApplicantOfferRequirement.PersonalStatement],
  ['portfolio', ApplicantOfferRequirement.Portfolio]
]);

export const ApplicantRequirements: Record<ApplicantOfferRequirement, string> = {
  [ApplicantOfferRequirement.AcademicCertificate]: OfferTaskLabel.AcademicCertificate,
  [ApplicantOfferRequirement.AcademicResults]: OfferTaskLabel.AcademicResults,
  [ApplicantOfferRequirement.AcademicTranscript]: OfferTaskLabel.AcademicTranscript,
  [ApplicantOfferRequirement.EnglishLanguageCertificate]: OfferTaskLabel.EnglishLanguageCertificate,
  [ApplicantOfferRequirement.EnglishLanguageResults]: OfferTaskLabel.EnglishLanguageResults,
  [ApplicantOfferRequirement.Passport]: OfferTaskLabel.Passport,
  [ApplicantOfferRequirement.PhotoID]: OfferTaskLabel.PhotoID,
  [ApplicantOfferRequirement.CV]: OfferTaskLabel.CV,
  [ApplicantOfferRequirement.ProofOfManagerialExperience]: OfferTaskLabel.ProofOfManagerialExperience,
  [ApplicantOfferRequirement.LetterOfRecommendation]: OfferTaskLabel.LetterOfRecommendation,
  [ApplicantOfferRequirement.PersonalStatement]: OfferTaskLabel.PersonalStatement,
  [ApplicantOfferRequirement.ProofOfAddress]: OfferTaskLabel.ProofOfAddress,
  [ApplicantOfferRequirement.ProofOfNameChange]: OfferTaskLabel.ProofOfNameChange,
  [ApplicantOfferRequirement.NameAffidavit]: OfferTaskLabel.NameAffidavit,
  [ApplicantOfferRequirement.BirthCert]: OfferTaskLabel.BirthCert,
  [ApplicantOfferRequirement.ProofOfImmigrationStatus]: OfferTaskLabel.ProofOfImmigrationStatus,
  [ApplicantOfferRequirement.Portfolio]: 'Portfolio'
};

export enum ApplicantOfferRequirementStatus {
  Assess = 'Assess',
  Satisfied = 'Satisfied',
  Condition = 'Condition',
  Exempt = 'Exempt',
  NotSatisfied = 'NotSatisfied'
}

export enum ApplicantOfferRequirementSection {
  Identity = 'Identity',
  AcademicRequirements = 'Academic Requirements',
  LanguageRequirements = 'Language Requirements',
  EducationRequirements = 'Education Requirements',
  EducationHistory = 'Education History',
  EnglishLanguage = 'English Language',
  Employment = 'Employment',
  Immigration = 'Immigration',
  ImmigrationHistory = 'Immigration History',
  References = 'References',
  PersonalStatement = 'Personal statement',
  Portfolio = 'Portfolio',
  Custom = 'Custom requirements'
}

export enum ApplicantOfferStatus {
  Applied = 'Applied',
  Draft = 'Draft',
  Conditional = 'Conditional',
  Unconditional = 'Unconditional',
  Withdrawn = 'Withdrawn',
  Rejected = 'Rejected',
  Completed = 'Completed'
}

export enum ApplicantOfferPaymentStatus {
  Request = 'Request',
  Review = 'Review',
  Exempt = 'Exempt',
  Approved = 'Approved'
}

export enum ApplicantStatusReason {
  EntryCriteriaNotMet = 'EntryCriteriaNotMet',
  FailedAcademicAssessment = 'FailedAcademicAssessment',
  FailedCredibilityAssessment = 'FailedCredibilityAssessment',
  FraudulentApplication = 'FraudulentApplication',
  CourseClosure = 'CourseClosure',
  CourseFull = 'CourseFull',
  UnableToOfferCourse = 'UnableToOfferCourse',
  DeadlineHasPassed = 'DeadlineHasPassed',
  ClosedByApplicant = 'ClosedByApplicant',
  AcceptedByApplicant = 'AcceptedByApplicant',
  CompletedByApplicant = 'CompletedByApplicant',
  WithdrawnOnCompletion = 'WithdrawnOnCompletion',
  Other = 'Other'
}

export enum ApplicantOfferResponseStatus {
  Accepted = 'Accepted',
  Declined = 'Declined'
}

export enum ApplicantOfferConditionType {
  Conditional = 'Conditional',
  Unconditional = 'Unconditional'
}

export enum ApplicantStatusObjName {
  ConditionalStatus = 'conditionStatus',
  UnconditionalStatus = 'unConditionStatus'
}

export enum ApplicantOfferRequirementActionStatus {
  ToDo = 'To do',
  Done = 'Done'
}

export enum EntryPoint {
  Year1 = 'Year 1',
  Year2 = 'Year 2',
  Year3 = 'Year 3',
  Year4 = 'Year 4',
  Year5 = 'Year 5',
  Year6 = 'Year 6'
}

export enum ApplicantOfferPaymentMethod {
  Deposit = 'Deposit',
  Sponsorship = 'Sponsorship',
  SLCFunding = 'SLCFunding'
}

export enum ApplicantOfferPaymentSponsorType {
  UkGovernment = 'UkGovernment',
  BritishCouncil = 'BritishCouncil',
  YourGovernment = 'YourGovernment',
  InternationalOrganisation = 'InternationalOrganisation',
  InternationalCompany = 'InternationalCompany'
}

export enum ScholarshipType {
  FIXED = 'FIXED',
  PERCENTAGE = 'PERCENTAGE'
}
